import {Component} from '@angular/core';

import budgetConfig from '../used-budget/table-config.json';

@Component({
  selector: 'app-total-budget',
  templateUrl: './total-budget.component.html',
  styleUrls: ['./total-budget.component.scss']
})
export class TotalBudgetComponent {
  private tableConfig: any;
  public columns: string[];

  constructor() {
    this.columns = [
      'regional_name',
      'inspector_name',
      'sales_group_name',
      'material_name',
      'category_name',
      'is_led_name',
      'initial_quantity',
      'returns_to_repair',
      'returns_ready',
      'redistributions',
      'new-redistribution',
      'disasters',
      'bound',
      'sent',
      'physical_budget',
      'available_budget',
      'actions'
    ];
    this.tableConfig = budgetConfig;
  }
}
